if (!customElements.get('read-more-text')) {
  customElements.define(
    'read-more-text',
    class ReadMoreText extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.product__description');
        this.toggle = this.querySelector('.product__description-toggle');
        this.moreLabel = this.querySelector('.product__description-toggle-more');
        this.lessLabel = this.querySelector('.product__description-toggle-less');

        if (!this.content || !this.toggle) return;

        const collapsedHeight = 192; // px, matches the CSS collapsed max-height

        if (this.content.scrollHeight > collapsedHeight + 20) {
          this.content.classList.add('is-collapsed');
          this.toggle.classList.remove('hidden');
        }

        this.toggle.addEventListener('click', () => this.onToggleClick());
      }

      onToggleClick() {
        const expanded = this.content.classList.toggle('is-expanded');
        this.content.classList.toggle('is-collapsed', !expanded);
        this.moreLabel.classList.toggle('hidden', expanded);
        this.lessLabel.classList.toggle('hidden', !expanded);
      }
    }
  );
}
